import ensurePath from 'redux/ensurePath'
import immerize from '../immerize'

const initialState = {
  status: '',
  error: null,
  zones: {},
  tags: {},
  tagsList: [],
  alert: {
    section: {
      id: 0,
      valid: false,
      invalid: false,
      message: '',
    },
    color: {
      id: 0,
      valid: false,
      invalid: false,
      message: '',
    },
    telegram: {
      id: 0,
      valid: false,
      invalid: false,
      message: '',
    },
    _create: {
      id: '',
      valid: false,
      invalid: false,
      message: '',
    },
    _point: {
      id: '',
      zone: '',
      valid: false,
      invalid: false,
      message: '',
    },
  },
}

function reducer(state = initialState, action) {
  let data
  switch (action.type) {
    case 'CLEAR_STORE':
      state = initialState
      break
    case 'ZONES_INFO_INIT':
      data = action.payload.data

      state.error = null
      state.status = 'ZONES_INFO_INIT'
      state.zones = { ...state.zones, ...data }
      break
    case 'ZONES_LIST_FULFILLED':
      updateZoneList(state, action.payload.data)
      break
    case 'ZONES_UPDATE_ALERT':
      updateZoneAlert(state, action.payload)
      break
    default:
      return state
  }
  return state
}

const updateZoneList = (state, zonelist) => {
  ensurePath(state, ['zones'])
  ensurePath(state, ['tags'])

  const newZones = {}
  const newTags = {}
  const newTagsList = []

  zonelist.forEach((zone) => {
    const { checkpoints, ..._zone } = zone

    const __zone = {
      ..._zone,
      byid: {},
      list: [],
    }
    checkpoints.forEach((point) => {
      __zone.byid[point.serialNumber] = point
      __zone.list.push(point.serialNumber)
    })

    newZones[zone.section] = zone
    newTags[zone.section] = __zone
    newTagsList.push(zone.section)
  })

  state.zones = newZones
  state.tags = newTags
  state.tagsList = newTagsList
}

const updateZoneAlert = (state, payload) => {
  state.alert[payload.type] = {
    ...state.alert[payload.type],
    ...payload.status,
  }
}

export default immerize(reducer)
